import { TextField } from '@mui/material';
import { useRef, useEffect, useState } from 'react';

const TextInput = (props : any) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [cursorPosition, setCursorPosition] = useState<number | null>(null);

    const handleChange = (arg : any) => {
        let { value } = arg.target;
        let newCursorPosition = arg.target.selectionStart;

        if (props.valueName === 'refno') {
            const originalLength = value.length;
            value = value.replace(/\s+/g, ''); // Remove all spaces
            const newLength = value.length;
            newCursorPosition -= (originalLength - newLength); // Adjust cursor position
        } else if (value.startsWith(' ')) {
            value = value.trimStart();
        }
        if (inputRef.current) {
            setCursorPosition(newCursorPosition);
        }
        props.changeFun(props.valueName, value);
    };

    useEffect(() => {
        if (inputRef.current && cursorPosition !== null) {
            inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
    }, [props.formValue, cursorPosition]);

    return (
        <>
            <TextField
                id="standard-basic"
                autoComplete='off'
                name={props?.valueName}
                label={props.label}
                value={props.formValue ? props.formValue : ''}
                variant="standard"
                sx={{
                    minWidth: '95%',
                    '& .MuiFormLabel-asterisk': {
                        color: 'red',
                    },
                }}
                className={props.className}
                size="small"
                InputLabelProps={{
                    style: { fontSize: '13px' }
                }}
                {...props.register}
                onChange={handleChange}
                inputProps={{
                    readOnly: props.readOnly,
                    maxLength: props.maxLength,
                    ref: inputRef,
                    "aria-autocomplete": 'none'
                }}
                disabled={props.disabled}
                required={props.required}
            />
            {props.errors && (props.errors[props.valueName]?.type === "pattern") &&
                <p role="alert" className='error-msg'>{props?.errorMessage?.pattern ?? `* ${props.label} is invalid`}</p>
            }
            {props.errors && (props.errors[props.valueName]?.type === "required") &&
                <p role="alert" className='error-msg'>{props?.errorMessage?.required ?? `* ${props.label} is required`}</p>
            }
            {props.errors && (props.errors[props.valueName]?.type === "minLength") &&
                <p role="alert" className='error-msg'>{props?.errorMessage?.minLength ?? `* ${props.label} must be at least ${props.minLength} characters`}</p>
            }
        </>
    );
}


export default TextInput;